import { z } from 'zod';

export const getPlusOneConfigFormSchema = (maxRegisteredPlusOnes?: number): z.ZodType<any> => {
  const minAllowed = maxRegisteredPlusOnes && maxRegisteredPlusOnes > 1 ? maxRegisteredPlusOnes : 1;
  const errorMessage =
    maxRegisteredPlusOnes && maxRegisteredPlusOnes > 1
      ? `There are guests with ${maxRegisteredPlusOnes} confirmed plus one guests. ` +
        `Increase the number of allowable plus one guests, or remove them from the guest list.`
      : 'Plus one guests must be at least 1';

  return z.object({
    allowPlusOnes: z.boolean(),
    maxPlusOnes: z.coerce
      .number({ invalid_type_error: errorMessage })
      .int()
      .min(minAllowed, errorMessage)
      .max(10, 'Plus one guests must be less than 10'),
    collectQuestionnaireResponses: z.boolean(),
    sendEmailNotification: z.boolean().optional(),
    sendSlackNotification: z.boolean().optional()
  });
};

export const PlusOneConfigFormSchema = getPlusOneConfigFormSchema();

export type PlusOneConfigFormValues = z.infer<typeof PlusOneConfigFormSchema>;
